import { render } from "./branch-detail.vue?vue&type=template&id=1359eb55"
import script from "./branch-detail.vue?vue&type=script&lang=js"
export * from "./branch-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__